<template>
  <div>
    <div class="flex flex-col items-center mb-16">
      <div class="relative w-full lg:w-2/3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="absolute w-6 h-6 top-3 left-3"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
        <input
          type="text"
          class="w-full form-input"
          style="padding-left: 3rem !important"
          id="search"
          v-model="search"
          :placeholder="trans.get('partners.view.search_by')"
          autocomplete="off"
          @keyup.enter="searchPartners"
          @input="searchPartners"
        />
        <button
          v-if="search"
          class="absolute cursor-pointer right-3 top-4"
          @mousedown.prevent.stop="search = null"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-5 h-5"
            viewBox="0 0 18 18"
          >
            <g
              fill="none"
              fill-rule="evenodd"
              stroke="#053633"
              stroke-width="1.5"
            >
              <circle cx="9" cy="9" r="8.325" />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5.4,9 L12.6,9 M9,5.4 L9,12.6"
                transform="rotate(45 9 9)"
              />
            </g>
          </svg>
        </button>
      </div>
      <div class="absolute" v-if="loading">
        <div class="flex items-center justify-center">
          <img
            class="inline-block w-24 md:w-28"
            src="/assets/svgs/loading.svg"
          />
        </div>
      </div>
    </div>
    <div>
      <div v-for="partner_type in partner_types" :key="partner_type.id">
        <p class="mb-4 classic-h4">{{ partner_type.title }}</p>
        <ol class="flex flex-wrap mb-16 -mx-3" v-if="partners.length">
          <li
            class="w-full p-3 sm:w-1/2 md:w-1/3 xl:w-1/4"
            v-for="partner in filterPartners(partner_type.id)"
            :key="partner.id"
          >
            <partner-card :partner="partner" :partner_type="partner_type">
            </partner-card>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      partners: {},
      search: null,
      partner_types: [],
      loading: false,
    };
  },

  mounted() {
    this.getParterTypes();
    this.searchPartners();
  },

  methods: {
    getParterTypes() {
      let vm = this;

      axios.get("/partner-types").then((response) => {
        vm.$set(vm, "partner_types", response.data);
      });
    },

    searchPartners() {
      let vm = this;

      vm.loading = true;

      axios
        .post("/partners/filter", { search: this.search })
        .then((response) => {
          vm.$set(vm, "partners", _.orderBy(response.data, ["title"]));
          document.getElementById("search").focus();
          vm.loading = false;
        });
    },

    filterPartners(partnerType) {
      return _.filter(this.partners, { partner_type_id: partnerType });
    },
  },

  watch: {
    search: function (value) {
      if (!value) {
        this.searchPartners();
      }
    },
  },
};
</script>
